import React from 'react';
import { SnowFlower } from './HomeschoolComp';
import { motion } from 'framer-motion';
import ReactPlayer from 'react-player';

const HomeschoolSection7 = () => {
  return (
    <div className="relative flex flex-col items-center overflow-hidden bg-[#eb5d1a]">
      <div className="w-full max-w-[480px]">
        <section className="flex flex-col items-center p-5 pt-[80px]">
          <SnowFlower color="white" opacity={1} width={24} />
          <div className="mt-3 text-center text-3xl text-white md:text-4xl">
            젭스영어교실,
            <div className="font-bold">이렇게 시작하세요!</div>
          </div>
        </section>
        <section className="flex w-full py-20 pr-10">
          <div className="relative mx-5 w-[1px] bg-[#ffc1a4]">
            <div className="absolute bottom-[-2px] left-1 h-3 w-[1px] rotate-45 bg-[#ffc1a4]"></div>
          </div>
          <div className="mt-[-12px] flex-1 text-sm text-white">
            <Card
              head="Case 01"
              title="가정에서 자녀와 함께 영어교실로 운영"
              url="https://youtu.be/quUKGugiVvs?si=q_CZ-szNrnkAt7bP"
            />
            <Dash />
            <Card
              head="Case 02"
              title="집에서 공부방으로 학생을 모집하여 운영 - 키즈"
              url="https://youtu.be/tfY-UbpWg1Q?si=9OyH0TBDc-u4j-w1"
            />
            <Dash />
            <Card
              head="Case 03"
              title="교회 주중 교습소로 활용"
              url="https://youtu.be/UD1P3GtEnVo?si=2Wi0T-4w3nn3N2Lg"
            />
            <Dash />
            <Card
              head="Case 04"
              title="대안학교에서 영어교과로 활용"
              url="https://youtu.be/75jgHQDdwp8?si=hgR43vR6MAH_sQeY"
            />
            <div className="h-20"></div>
          </div>
        </section>
      </div>
    </div>
  );
};

const Card = ({
  head,
  title,
  url,
}: {
  head: string;
  title: string;
  url: string;
}) => (
  <div className="relative text-base font-bold md:text-lg">
    {/* historyLine의 점 */}
    <div className="absolute left-[-24px] top-3 h-2 w-2 rounded-full bg-[#ffc1a4]"></div>

    {/* case */}
    <motion.div
      className="w-fit rounded-full border-[1px] border-white px-3 py-0.5"
      initial={{ x: -20 }}
      whileInView={{ x: 0 }}
    >
      {head}
    </motion.div>
    {/* title */}
    <motion.div
      className="mt-2"
      initial={{ y: -20, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
    >
      {title}
    </motion.div>

    <div className="mt-5 aspect-video w-full overflow-hidden rounded-xl">
      <ReactPlayer width={'100%'} height={'100%'} url={url} controls />
    </div>
  </div>
);
const Dash = () => (
  <div className="my-8 border-t border-dashed border-[#ff7d40]"></div>
);

export default HomeschoolSection7;
